import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S33CondensedSpecialSection } from '../components/interactive-sections/S33CondensedSpecial';
import { getPaddingInputs } from "../utils/builderSharedInputs";

Builder.registerComponent(S33CondensedSpecialSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S33CondensedSpecial,
  friendlyName: 'S33 Condensed Special',
  inputs: [
    {
      name: 'bannerImage',
      type: 'file',
      friendlyName: 'Banner Image',
      helperText: 'Main image for the banner (required)',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      required: true,
      defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F97bcb065d31d43068f649c8b833e448c?width=200&height=200',
    },
    {
      name: 'bannerAlt',
      type: 'string',
      friendlyName: 'Banner Alt Text',
      helperText: 'Alt text for the banner image (required)',
      required: true,
      defaultValue: 'Milan Laser Condensed Special Banner',
    },
    {
      name: 'bannerPosition',
      type: 'string',
      friendlyName: 'Banner Position',
      helperText: 'Position of the banner image (top or right)',
      enum: ['top', 'right'],
      defaultValue: 'top',
    },
    {
      name: 'badgeImage',
      type: 'file',
      friendlyName: 'Badge Image',
      helperText: 'Optional badge image (if present, badgeAlt is required)',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe8cc0ff7a853473ebecdc56459f7fe11',
    },
    {
      name: 'badgeAlt',
      type: 'string',
      friendlyName: 'Badge Alt Text',
      helperText: 'Alt text for the badge image (required if badgeImage is set)',
    },
    {
      name: 'badgePosition',
      type: 'string',
      friendlyName: 'Badge Position',
      helperText: 'Position of the badge (top-right or bottom-right)',
      enum: ['top-right', 'bottom-right'],
      defaultValue: 'top-right',
    },
    {
      name: 'body',
      type: 'longText',
      friendlyName: 'Body Content',
      helperText: 'Main body content',
      required: true,
      defaultValue: `The pool’s open — are you ready? Dive into silky-smooth skin for life and win up to 50% OFF plus extra savings this month! Every purchase includes lifetime access to FREE touch-ups at any Milan Laser clinic. Plus, your first treatment’s FREE when you complete a consultation before the end of the month. Visit your local Milan Laser by May 31 to get your Scratch & Save card and see your savings!`,
    },
    {
      name: 'ctaText',
      type: 'string',
      friendlyName: 'CTA Text',
      helperText: 'Text for the call-to-action button',
      required: true,
      defaultValue: 'Learn More',
    },
    {
      name: 'ctaHref',
      type: 'string',
      friendlyName: 'CTA Link',
      helperText: 'URL for the call-to-action button',
      required: true,
      defaultValue: '/',
    },
    {
      name: 'className',
      type: 'string',
      friendlyName: 'Custom Class Name',
      helperText: 'Optional custom CSS class for the component',
    },
    {
      name: 'disclaimerText',
      type: 'string',
      friendlyName: 'Disclaimer Text',
      helperText: 'Optional disclaimer text to display below the content',
      defaultValue: '*Call or visit clinic for details. Full-body purchases are not eligible for discount.'
    },
    {
      name: 'loading',
      type: 'string',
      friendlyName: 'Image Loading',
      helperText: 'Image loading behavior (lazy or eager)',
      enum: ['lazy', 'eager'],
      defaultValue: 'lazy',
    },
    ...getPaddingInputs()
  ],
}); 